import MessageBubble from "@/components/ChatContainer/messageBubble.component";
import { ChatMessage } from "@/types";
import React, { useLayoutEffect, useRef } from "react";

type MessagesContainerProps = {
  messages: ChatMessage[];
  sendingMessage: ChatMessage | null;
};

const MessagesContainer: React.FC<MessagesContainerProps> = ({
  messages,
  sendingMessage,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages, sendingMessage]);

  return (
    <div ref={containerRef} className="mt-4 flex-grow overflow-y-auto">
      {messages.length === 0 && !sendingMessage && (
        <div className="text-center">
          No messages yet. Start the conversation!
        </div>
      )}
      {messages.map((message) => {
        return <MessageBubble key={message.timestamp} message={message} />;
      })}
      {sendingMessage && (
        <MessageBubble
          key={sendingMessage.timestamp}
          message={sendingMessage}
          isSending={true}
        />
      )}
    </div>
  );
};

export default MessagesContainer;
